import { memo, useCallback, useEffect, useState } from "react";

import { classNames } from "shared/lib/classNames/classNames";

import cls from "./SociometryClassesList.module.scss";
import axios from "axios";
import { Layout } from "components/Layout";
import { BackButton } from "components/BackButton";
import { useHistory, useParams } from "react-router-dom";
import { IClassWithStatus } from "shared/types/class";
import { ISchool } from "shared/types/schooll";
import { getSociometrySessionStatusMeta } from "pages/sociometry/helpers/sociometrySessionStatusMap";
import { SociometryDelete } from "../SociometryDelete/SociometryDelete";

interface SociometryClassesListProps {
    className?: string;
}

export const SociometryClassesList = memo((props: SociometryClassesListProps) => {
    const { className } = props;
    const history = useHistory();

    const { id: schoolId } = useParams<{ id: string }>();

    const [classes, setClasses] = useState<IClassWithStatus[]>([]);
    const [school, setSchool] = useState<ISchool | null>(null);
    useEffect(() => {
        (async () => {
            const { data } = await axios.get<{ school: ISchool; classes: IClassWithStatus[] }>(
                `sociometry/psych/school/${schoolId}/classes`,
            );
            setClasses(data.classes);
            setSchool(data.school);
        })();
    }, [schoolId]);

    const syncClasses = useCallback((sessionId: string) => {
        setClasses((prev) => prev.filter((schoolClass) => schoolClass.sessionId !== sessionId));
    }, []);

    const onClickItem = useCallback(
        (sessionId: string) => {
            history.push(`/sociometry/results/${sessionId}`);
        },
        [history],
    );

    return (
        <Layout>
            <div className={classNames(cls.sociometryClassesList, {}, [className])}>
                <header className={cls.header}>
                    <BackButton />
                    <p className={cls.title}>{school?.name}</p>
                </header>

                <div className={cls.classesList}>
                    {classes.map((schoolClass) => (
                        <div
                            key={schoolClass.sessionId}
                            className={cls.class}
                            onClick={() => onClickItem(schoolClass.sessionId)}
                        >
                            <div>
                                <p className={cls.schoolClass}>
                                    Класс: {schoolClass.class.number}
                                    {schoolClass.class.letter}
                                </p>
                                <p className={cls.startDate}>
                                    Дата назначения:{" "}
                                    <span className={cls.statusValue}>
                                        {new Date(schoolClass.createdAt).toLocaleDateString()}
                                    </span>
                                </p>
                            </div>
                            <p className={cls.status}>
                                Статус:{" "}
                                <span className={cls.statusValue}>
                                    {getSociometrySessionStatusMeta(schoolClass?.status || "Pending").label}
                                </span>
                            </p>
                            <p className={cls.pupilsCount}>
                                Прошли тестирование:{" "}
                                <span className={cls.statusValue}>{schoolClass.completionRate}</span>
                            </p>
                            <SociometryDelete
                                className={cls.sociometryDelete}
                                sessionId={schoolClass.sessionId}
                                syncClasses={syncClasses}
                            />
                        </div>
                    ))}
                </div>
            </div>
        </Layout>
    );
});

SociometryClassesList.displayName = "SociometryClassesList";
